import React from 'react';
import { motion } from 'framer-motion';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin, 
  Copyright 
} from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { icon: Facebook, url: '#' },
    { icon: Twitter, url: '#' },
    { icon: Instagram, url: '#' },
    { icon: Linkedin, url: '#' },
  ];

  return (
    <footer className="bg-gray-900/70 backdrop-blur-md py-8">
      <div className="container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center space-y-4"
        >
          <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500">
            Beta Pixel Studio
          </h3>

          <p className="text-gray-300 max-w-xl text-center">
            Transforming Digital Visions into Pixel-Perfect Realities. 
            We deliver creative digital solutions that empower your brand.
          </p>

          {/* <div className="flex space-x-4">
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2 }}
                className="text-gray-300 hover:text-cyan-500 transition-colors"
              >
                {React.createElement(social.icon, { size: 24 })}
              </motion.a>
            ))}
          </div> */}

          <div className="flex items-center text-gray-400 text-sm">
            <Copyright size={16} className="mr-2" />
            <span>2024 Beta Pixel Studio. All Rights Reserved.</span>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
